import { Heading, Spacer } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import { BillingPeriodSwitcher } from './components/BillingPeriodSwitcher'
import { HelpSection } from './components/HelpSection'

export const Header = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Heading weight={600}>{t('checkout.plans.header.title')}</Heading>

      <Spacer space={40} />

      <Row vertical='center' horizontal='space-between'>
        <HelpSection />

        <BillingPeriodSwitcher />
      </Row>
    </div>
  )
}

Header.displayName = 'CheckoutPlansHeader'
